export default __webpack_public_path__ + "static/media/tick.788415dc.svg";